export function AccessDeniedPage() {
  return (
    <div className="grid h-full place-items-center bg-fv-ink p-6">
      <div className="max-w-md rounded-panel bg-white p-8 text-center">
        <h1 className="text-xl font-bold text-fv-text">Use the Food Valve Ops app</h1>
        <p className="mt-2 text-sm text-fv-muted">
          This console is for Super Admin and Tech Admin. Operational workflows are in the Food Valve
          Ops mobile app.
        </p>
      </div>
    </div>
  );
}
